// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorStateView_root__sddIp","body":"ErrorStateView_body__3CRvu","img":"ErrorStateView_img__fd0FL","fill":"ErrorStateView_fill__2IUrP"};